import { useTranslation } from "react-i18next";
import { ChevronDown, ChevronRight, Pencil } from "lucide-react";
import { localName } from "../../lib/localName";

const TYPE_TONE = {
  asset: "text-primary",
  liability: "text-destructive",
  equity: "text-success",
  revenue: "text-success",
  cogs: "text-muted-foreground",
  expense: "text-destructive",
  other: "text-muted-foreground",
};

export const AccountRow = ({ row, open, onToggle, onEdit }) => {
  const { t, i18n } = useTranslation();
  const label = i18n.language === "ar" ? localName(row) : row.name;

  return (
    <div
      className="flex items-center gap-2 rounded-xl px-2 py-2 transition-shadow duration-300 hover:shadow-neu-in"
      style={{ paddingInlineStart: `${row.depth * 18 + 8}px` }}
      data-testid={`account-row-${row.code}`}
    >
      {row.hasKids ? (
        <button type="button" onClick={() => onToggle(row.code)} data-testid={`account-toggle-${row.code}`}>
          {open ? <ChevronDown className="h-4 w-4 text-primary" /> : <ChevronRight className="h-4 w-4 text-primary" />}
        </button>
      ) : (
        <span className="w-4" />
      )}
      <span className="font-mono text-xs font-bold" dir="ltr">
        {row.code}
      </span>
      <span className="min-w-0 flex-1 truncate text-sm font-semibold">{label}</span>
      <span className={`text-[10px] font-bold ${TYPE_TONE[row.type]}`}>{t(`acct.types.${row.type}`)}</span>
      {row.is_leaf ? (
        <span className="rounded-full border border-primary/40 px-2 py-0.5 text-[10px] font-bold text-primary">
          {t("acct.postable")}
        </span>
      ) : null}
      {onEdit ? (
        <button type="button" onClick={onEdit} data-testid={`account-edit-${row.code}`}
          className="text-muted-foreground transition-colors duration-300 hover:text-primary">
          <Pencil className="h-3.5 w-3.5" />
        </button>
      ) : null}
    </div>
  );
};
